<template>
  <div>
    <v-layout row wrap>
      <v-flex p-t-30>
        <div class="tituloBox p-b-30 border-top">
          <div class="bg-primary barraTitulo"></div>
          <v-btn icon @click="openBox()" right absolute>
            <v-icon>unfold_more</v-icon>
          </v-btn>
          <h1 class="text-info font-size-18">
            Qualificação
            <strong>Técnica</strong>
          </h1>
        </div>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-show="showBox">
      <v-flex infoDados>
        <v-card>
          <v-data-table
            :headers="localcabecalhoQualificacaoTecnica"
            :items="model.qualificacaoTecnica"
            :hide-actions="true"
            class="elevation-1"
          >
            <template slot="items" slot-scope="props">
              <td
                class="text-xs-left"
              >{{retornaNomeQualificacaoTecnica(listaDocsQualificacaoTecnica,props.item.codDocumento)}}</td>
              <td class="text-xs-left">{{props.item.numDocumento}}</td>
              <td class="text-xs-center" v-bind:class="{'dataVencida':verificaDataVencida(props.item.dtVencimento)}">{{props.item.dtVencimento | dataFormatada}}</td>
              <td v-if="$verificaPerfilCadastrador() || $verificaPerfilHabilitador()" class="text-xs-center naoImprimir">
                <a v-if="props.item.numDocumentoSEI" v-bind:href="props.item.arquivoUpload" target="_blank"><v-icon color="blue">attach_file</v-icon></a>
                                        <v-icon v-else color="grey">attach_file</v-icon> 
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import dominioService from "../../../services/dominioService";
import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import { mounted } from "vue-popperjs";

export default {
  name: "extrato-qualificacao-tecnica",
  mixins: [util],
  props: {//Propriedades que o objeto recebe como parametro
    model: Object, /*Solicitacao atual do Fornecedor*/
    dominio: Object,
    enums: Object
  },
  created() /*Metodo de start do componente*/{
    this.getListaDocsQualificacaoTecnica();
  },
  data() {//Declaracao de variaveis
    return {
      localcabecalhoQualificacaoTecnica: [],
      listaDocsQualificacaoTecnica: {},
      showBox: true,
    };
  },
  mounted(){
  if (this.$verificaPerfilCadastrador() || this.$verificaPerfilHabilitador()) {
    this.localcabecalhoQualificacaoTecnica = this.cabecalhoQualificacaoTecnica;
      this.localcabecalhoQualificacaoTecnica.push({
        text: this.$t("label.anexo"),
        align: "center",
        sortable: false,
        class: "naoImprimir",
      });
    }
  },
  
  methods: {//Declaracao de todos os metodos
    openBox() {
      //mostrar o box
      this.showBox = !this.showBox;
    },
    getListaDocsQualificacaoTecnica() {
      //resgatar os documentos de qualificacao tecnica
      dominioService
        .getListaDocsQualificacaoTecnica(this.model.familiaSolicitacao)
        .then(response => { /*resposta do servico*/
          this.listaDocsQualificacaoTecnica = response.data; /*dados de retorno*/
        });
    },
  }
};
</script>

<style scoped> /*CSS especifico do componente*/
.infoDados .v-card {
  padding: 15px;
}

.infoDados .linhaInfo {
  display: block;
  padding: 5px 0;
}

.theme--light.v-table thead {
  background: none;
}
</style>


